// App.tsx
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import AboutUsPage from './pages/AboutUsPage';
import ServicesPage from './pages/ServicesPage';
import OurWorkPage from './pages/OurWorkPage';
import TestimonialsPage from './pages/TestimonialsPage';
import ContactUsPage from './pages/ContactUsPage';
import RequestQuotePage from './pages/RequestQuotePage';
import GalleryPage from "./pages/GalleryPage";
import BlogListPage from "./pages/BlogListPage";
import BlogPostPage from "./pages/BlogPostPage";
import SEOHead from './components/ui/SEOHead';
import EmergencyBanner from './components/ui/EmergencyBanner';
import { captureAttribution } from './utils/attribution';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

/**
 * Stash the Google Ads click identifier on arrival.
 *
 * Runs on every navigation, not just first mount: the ad click can land on any
 * page, and the form the visitor eventually fills is usually a different one.
 */
const CaptureAttribution: React.FC = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    captureAttribution();
  }, [pathname, search]);

  return null;
};

const AppContent: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen font-sans antialiased bg-slate-100">
      <SEOHead />
      <EmergencyBanner />
      <Header />
      <ScrollToTop />
      <CaptureAttribution />
      <main className="flex-grow relative">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/our-work" element={<OurWorkPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/request-quote" element={<RequestQuotePage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
